import { Button, Typography } from '../../../designComponents';
import SelectDropDown from '../../../designComponents/SelectDropdown';
import { dropDownData } from './dropdownData';
import { CountryWrapperStyled } from './style';

const CountryComponent = () => {
  return (
    <CountryWrapperStyled>
      <div className="main-heading">
        <Typography variant="title" strong>
          Manage Translation
        </Typography>
        <div className="language">
          <Typography>English(US)</Typography>
          <Button>Default</Button>
        </div>
      </div>
      <Typography>
        The escape plan supports multiple languages for translation. Please
        select a language for translation.
      </Typography>
      <div>
        <Typography>Country</Typography>
        <SelectDropDown
          options={dropDownData}
          placeholder="Select a country"
          selected=""
          onSelect={() => {}}
        />
      </div>
      <Button>Translate</Button>
    </CountryWrapperStyled>
  );
};

export default CountryComponent;
